/**
 * Hook for managing database connections
 */

import { useState, useEffect } from 'react';
import { connectionsAPI } from '../api/enhancedApiService';
import { addSlugsToConnections } from '../utils/slugUtils';

export const useConnections = () => {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadConnections();
  }, []);

  const loadConnections = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await connectionsAPI.getAll();

      let rawConnections = [];
      if (response && response.data && response.data.connections) {
        rawConnections = response.data.connections;
      } else if (response && response.connections) {
        rawConnections = response.connections;
      } else if (Array.isArray(response)) {
        rawConnections = response;
      } else {
        console.warn('Unexpected connections response format:', response);
        setConnections([]);
        setError('Unexpected response format from connections API');
        return;
      }

      // Add slugs to connections for URL-friendly navigation
      const connectionsWithSlugs = addSlugsToConnections(rawConnections);
      setConnections(connectionsWithSlugs);
    } catch (err) {
      console.error('Error loading connections:', err);
      setError(err.message);
      setConnections([]);
    } finally {
      setLoading(false);
    }
  };

  const getConnectionBySlug = (slug) => {
    return connections.find(conn => conn.slug === slug);
  };

  const getConnectionById = (id) => {
    return connections.find(conn => conn.id === id);
  };

  return {
    connections,
    loading,
    error,
    refresh: loadConnections,
    getConnectionBySlug,
    getConnectionById
  };
};